/**
 * @module manifest/panelLayout/lineFamily
 * @description Config A：折线图族（Line + EventLine + PercentLine）面板布局
 */

import { ChartType, type TChartType } from '@dbl/core/chart';
import { type PanelTabLayout } from './types';

const lineBasicGroups = [
  'DataLabel',
  'NullHanding',
  'LegendColorSetting',
  'DisplayLimit',
  'XAxisSetting',
  'YAxisSetting',
  'LegendSetting',
  'ChartSwitch',
] as const;

const lineAdvancedGroups = ['EditReferenceLine'] as const;

const eventLineBasicGroups = [
  'DataLabel',
  'NullHanding',
  'LegendColorSetting',
  'XAxisSetting',
  'YAxisSetting',
  'LegendSetting',
] as const;

/** 百分比折线：lineFamily 通用项，无 ChartSwitch / ToolTipSetting */
const percentLineBasicGroups = [
  'DataLabel',
  'NullHanding',
  'LegendColorSetting',
  'DisplayLimit',
  'XAxisSetting',
  'YAxisSetting',
  'LegendSetting',
] as const;

export const LINE_FAMILY_PANEL_LAYOUT: Partial<
Record<TChartType, PanelTabLayout[]>
> = {
  [ChartType.Line]: [
    { id: 'basic', groups: lineBasicGroups },
    { id: 'advanced', groups: lineAdvancedGroups },
  ],
  [ChartType.EventLine]: [{ id: 'basic', groups: eventLineBasicGroups }],
  [ChartType.PercentLine]: [
    { id: 'basic', groups: percentLineBasicGroups },
    { id: 'advanced', groups: lineAdvancedGroups },
  ],
};

